export default __webpack_public_path__ + "static/500-48a90f29cb5c87cc589956697d37611c.png";